import React from 'react';
import Units from './units.js';
import ReactModal from 'react-modal';

const global  = require('./global.js');

class Build extends React.Component 
{
  constructor(props) 
  {
    super(props)
    this.state = { selected: 0, advanced: false, constants: [] };
    this.sens = {};
    this.wellgeo={};
    this.properties={};
    this.actions={};
    this.build={};
    this.data={};
    this.file=0;
    this.startdate=new Date(2021,0,1);
  }
  render() 
  {
    var file = 0; if ( typeof this.props.selected['build']!=='undefined' && 
                              this.props.selected['build']<global.common.data['build'].length) file = this.props.selected['build'];

    var u = new Units();
    var constants = global.common.data['build'][file].data.constants;
    var carray = [];
    for ( var key in constants )
    {
      carray.push({ key: key, value: this.state.constants[key], units: u.units[constants[key].unit][global.common.unitset], comment: constants[key].comment});
    }
    const constdisp=carray.map( function(obj,index)
    {
      var line = <tr key={index} ><td>{obj.key}</td><td>
                      <input  value={obj.value} type={'text'}  onChange={(e) => this.modify(e,obj.key)} ></input>
                   </td><td>{obj.units}</td><td>{obj.comment}</td></tr>; 
      return line;
    }, this );

    return (
      <table><tbody><tr>
        <td><div className='checkbuild'><button onClick={(e) => this.check(e) } >check and build</button></div></td>
        <td><button onClick={(e) => this.show(e) } >show</button></td>
        <td className="errorbox"><span className="adddel" onClick={(i) => this.adv(i)}><u>adv</u></span></td><td>&nbsp;&nbsp;</td>
            <ReactModal 
                 isOpen={this.state.advanced}
                 appElement={document.getElementById('root')}
                 className="Advanced"  >
                <table><tbody><tr><td>Advanced Options</td><td></td><td></td><td><i>change at your peril</i></td><td><span onClick={() => this.handleCloseModal()} >&times;</span></td></tr>
                <tr><td></td></tr>
                {constdisp}
                </tbody></table>
              </ReactModal>
        </tr></tbody></table>
      );
  }

  handleChange(event) 
  {
    var newstate = Object.assign(this.state);
    newstate.selected = event.target.selectedIndex;
    this.setState(newstate);
  }

  show()
  {
    this.props.report.go=false;
    this.props.trigger();
  }

  adv()
  {
    var newstate = Object.assign(this.state);
    newstate.advanced = true;
    var file = 0; if ( typeof this.props.selected['build']!=='undefined' && 
                              this.props.selected['build']<global.common.data['build'].length) file = this.props.selected['build'];
    for ( var key in global.common.data['build'][file].data.constants )
    {
      newstate.constants[key] = global.common.data['build'][file].data.constants[key].value;
    }     
    this.setState(newstate);
  }

  handleCloseModal()
  {
    var file = 0; if ( typeof this.props.selected['build']!=='undefined' && 
                              this.props.selected['build']<global.common.data['build'].length) file = this.props.selected['build'];
    for ( var key in global.common.data['build'][file].data.constants )
    {
      global.common.data['build'][file].data.constants[key].value = this.state.constants[key];
    } 
    var newstate = Object.assign(this.state);
    newstate.advanced = false;
    this.setState(newstate);
  }

  modify(e,k)
  {
    var newstate = Object.assign(this.state);
    newstate.constants[k] = e.target.value;
    this.setState(newstate);
  }

  check()
  {
    var data = global.common.data;
    this.data = global.common.data;

    var file = 0; if ( typeof this.props.selected['build']!=='undefined' && 
                              this.props.selected['build']<data['build'].length) file = this.props.selected['build'];
    this.file = file;
    this.build = this.getsection(data,'build',file);

    var buildrevs = '';
    for ( var i=0; i<global.common.listsect.length; i++ )
    {
      if ( global.common.listsect[i]!=='build' ) 
      { 
        var sectfile = this.data['build'][this.file].data[this.props.sixxc][0].para[i].value;
        buildrevs+=data[global.common.listsect[i]][sectfile].data.revision.rev.toString();
        data['build'][file][global.common.listsect[i]] = this.data['build'][this.file].data[this.props.sixxc][0].para[i].value
      }
    }

    data['build'][file].buildrevs = buildrevs;

    // 
    // Part of the final report
    //
    var rpt_errors   = [];
    var rpt_warnings = [];
    var rpt_layer    = [];
    var rpt_depth    = {};
    var rpt_wells    = [];

//-----------------------------------------------------------------
//     Geology
//-----------------------------------------------------------------
    var top = this.getparat('formation',0,0,'float');
    var bottom = top;

    var error_geom = {};

    for ( i=0; i<this.getparat('layer',0,0,'len'); i++ )
    {
      var layer  = this.getparat('layer',i,0,'name');
      var order  = this.getparat('layer',i,0,'int');
      var dz     = this.getparat('layer',i,1,'float');
      var rock   = this.getparat('layer',i,2,'');

      bottom += dz;

      var irock   = this.checkexistst('rock',rock);

      var basic='none';
      var geomech='none';
      var scal='none';

      if ( irock<0   ) 
      { 
        rpt_errors.push('Layer '+layer+' refers to rock '+rock+' which doesn\'t exist');
      }
      else
      {
        var iporoperm = this.checkexists(this.getparat('poroperm',0,0,'obj'),this.getparat('rock',irock,0,''));
        if ( iporoperm<0 ) rpt_errors.push('Rock '+rock+' refers to poroperm '+this.getparat('rock',irock,0,'')+' which doesn\'t exist');
        basic = this.getparat('rock',irock,0,'');
        var pp = this.getporoperm(this.getparat('poroperm',0,0,'obj'),basic);
        if ( global.common.data.options.completions && parseInt(pp.nporo)<1 && parseInt(pp.nporo)>2 ) rpt_errors.push('Rock '+rock+' nporo must be 1 or 2 ('+pp.nporo+')');
 
        var igeomech = this.checkexists(this.getparat('geomech',0,0,'obj'),this.getparat('rock',irock,1,''));
        if ( igeomech<0 ) rpt_errors.push('Rock '+rock+' refers to geomech '+this.getparat('rock',irock,1,'')+' which doesn\'t exist');        
        geomech = this.getparat('rock',irock,1,'');
        if ( !(geomech in error_geom) ) error_geom[geomech]=0;
        var strength = this.getparat('geomech',igeomech,0,'');
        var maxnegsr = -this.build['constants'].negstressb.value;
        if ( strength<0         && error_geom[geomech]===0 ) { rpt_errors.push('Geomech '+geomech+' has strength <0 '); error_geom[geomech]++; }  
        if ( strength>=maxnegsr && error_geom[geomech]===0 ) { rpt_errors.push('Geomech '+geomech+' has strength >= '+maxnegsr);  error_geom[geomech]++; }  

        var iscal = this.checkexists(this.getparat('scal',0,0,'obj'),this.getparat('rock',irock,2,''));
        if ( iscal<0 ) rpt_errors.push('Rock '+rock+' refers to scal '+this.getparat('rock',irock,2,'')+' which doesn\'t exist');
        scal = this.getparat('rock',irock,2,'');      
      }

      rpt_layer.push({ layer: layer, order: order, dz: dz, rock: rock, basic: basic, geomech: geomech, scal: scal, nporo: pp.nporo });
    }

    var fdz = bottom-top;
    rpt_depth={top: top,bottom: bottom, tdz: fdz};

//-----------------------------------------------------------------
//   Wells & Fracs
//-----------------------------------------------------------------

    var wellsused={};
    var fracsused={};
    var stagesused={};
    var wellfracs={};
    var prodsused={};

    if ( this.getparat('well',0,0,'len')===0 ) rpt_errors.push('No wells present');

    for ( i=0; i<this.getparat('schedule',0,0,'len'); i++ )
    {
      var sched  = this.getparat('schedule',i,0,'name');
      var well   = this.getparat('schedule',i,0,'');
      var frac   = this.getparat('schedule',i,1,'');
      var ifrac  = this.checkexistst('frac',frac);
      if ( global.common.data.options.completions ) ifrac = this.checkexistst('completion',frac);
      if ( ifrac>=0 ) 
      {
        var stages = this.getparat('frac',ifrac,3,'');

        var time   = this.getparat('schedule',i,2,'float');

        var injf ='';
        var prop ='';

        var iwell = this.checkexistst('well',well);
        if ( iwell<0 ) rpt_errors.push('Well '+well+' scheduled in '+sched+' doesn\'t exist');
        else
        {
          if ( typeof wellsused[well]==='undefined' ) wellsused[well]=1; else wellsused[well]++;

          if ( this.getparat('well',iwell,0,'type')==='imported' )
          {
            var z = this.getparat('well',iwell,0,'obj')[iwell].z;
            var mx = -10000; var mn = 1000000;
            for ( var iz=0; iz<z.length; iz++ )
            {
              mx = Math.max(z[iz],mx);
              mn = Math.min(z[iz],mn);
            }
            if ( mx>bottom || mn<top ) rpt_warnings.push('Well '+well+' is in part ('+mn+','+mx+') outside the formation');
          }
          else
          {
            var depth = this.getparat('well',iwell,0,'float');
            if ( depth<top || depth>bottom ) rpt_errors.push('Well '+well+' is at a depth ('+depth+') outside the formation');
          }
        }

        if ( global.common.data.options.completions ) 
        {
          var icomp = this.checkexistst('completion',frac);
          if ( icomp<0 ) rpt_errors.push('Completion '+frac+' scheduled in '+sched+' doesn\'t exist');
          else
          {
            if ( typeof fracsused[frac]==='undefined' ) fracsused[frac]=1; else fracsused[frac]++;
          }
        }
        else
        {
          ifrac = this.checkexistst('frac',frac);
          if ( ifrac<0 ) rpt_errors.push('Frac '+frac+' scheduled in '+sched+' doesn\'t exist');
          else
          {
            if ( typeof fracsused[frac]==='undefined' ) fracsused[frac]=1; else fracsused[frac]++;
          }
          if ( typeof wellfracs[well+':'+frac]==='undefined' ) wellfracs[well+':'+frac]=1; else wellfracs[well+':'+frac]++;
        }
        var istag = this.checkexists(this.getparat('stages',0,0,'obj'),stages);
        if( !(global.common.data.options.completions && stages==='' ) ) 
        {
          if ( istag<0 ) rpt_errors.push('Stages '+stages+' scheduled in '+sched+' doesn\'t exist');
          else
          {
            if ( typeof stagesused[stages]==='undefined' ) stagesused[stages]=1; else stagesused[stages]++;
            injf = this.getparat('stages',istag,3,'');
            var iinjf = this.checkexists(this.getparat('injfluid',0,0,'obj'),injf);
            if ( iinjf<0 ) rpt_errors.push('Injection fluid '+injf+' used in '+stages+' doesn\'t exist');
            else 
            {
              prop = this.getparat('injfluid',iinjf,1,'');
              if ( prop!=='none' && prop!=='' )
              {
                var iprop = this.checkexists(this.getparat('proppant',0,0,'obj'),prop);
                if ( iprop<0 ) rpt_errors.push('Proppant '+prop+' used in '+injf+' doesn\'t exist');
              }
            }
          }
        }
      }
      else
      {
        rpt_errors.push('Frac '+frac+' scheduled in '+sched+' doesn\'t exist');
      }

      var prod   = this.getparat('schedule',i,3,'');
      var iprod  = this.checkexistst('production',prod);
      if ( iprod>=0 ) 
      {
        iwell = this.checkexistst('well',well);
        if ( iwell<0 ) rpt_errors.push('Well '+well+' scheduled in '+sched+' doesn\'t exist');
        else
        {
          if ( typeof wellsused[well]==='undefined' ) wellsused[well]=1; else wellsused[well]++;

          if ( this.getparat('well',iwell,0,'type')!=='imported' )
          {
            depth = this.getparat('well',iwell,0,'float');
            if ( depth<top || depth>bottom ) rpt_errors.push('Well '+well+' is at a depth ('+depth+') outside the formation');
          }
        }
        if ( typeof prodsused[prod]==='undefined' ) prodsused[prod]=1; else prodsused[prod]++;
      }

      var tfrac = this.getparat('schedule',i,2,'float');
      var tprod = this.getparat('schedule',i,4,'float');
      if ( Math.abs(tfrac-tprod)<0.00001 ) rpt_errors.push('Schedule '+sched+' can\'t have frac time = production time ');

      rpt_wells.push({ sched: sched, well: well, frac: frac, stages: stages, time: time, injf: injf, prop: prop});  
    }

    for ( const wf in wellfracs )
    {
      var n=wellfracs[wf];
      if ( n>1 ) 
      {
        well = wf.substr(0,wf.search(':'));
        frac = wf.substr(wf.search(':')+1);
        rpt_errors.push('Frac '+frac+' is scheduled in Well '+well+' more than once ('+n+')');
      }
    }

    for ( i=0; i<this.getparat('well',0,0,'len'); i++ )
    {
      well = this.getparat('well',i,0,'name');
      if ( typeof wellsused[well]==='undefined' ) rpt_warnings.push('Well '+well+' is declared but not scheduled');
    }

    if( global.common.data.options.completions ) 
    {
      for ( i=0; i<this.getparat('completion',0,0,'len'); i++ )
      {
        frac = this.getparat('completion',i,0,'name');
        if ( typeof fracsused[frac]==='undefined' ) rpt_warnings.push('Completion '+frac+' is declared but not scheduled');
      }
    }
    else
    {
      for ( i=0; i<this.getparat('frac',0,0,'len'); i++ )
      {
        frac = this.getparat('frac',i,0,'name');
        if ( typeof fracsused[frac]==='undefined' ) rpt_warnings.push('Frac '+frac+' is declared but not scheduled');
      }
    }

    for ( i=0; i<this.getparat('stages',0,0,'len'); i++ )
    {
      stages = this.getparat('stages',i,0,'name');
      if ( typeof stagesused[stages]==='undefined' ) rpt_warnings.push('Stages '+stages+' is declared but not used');
    }

    for ( i=0; i<this.getparat('production',0,0,'len'); i++ )
    {
      prod = this.getparat('production',i,0,'name');
      if ( typeof prodsused[prod]==='undefined' ) rpt_warnings.push('Production '+prod+' is declared but not scheduled');
    }

    //
    // Store
    //
    rpt_layer.sort( function(a,b) { return a.order-b.order } );  // Order layers

    if ( rpt_errors.length===0 )
    {
      this.builddeck(this.props.sixxc,wellsused,rpt_warnings);
    }
    else
    {
      global.alertx("Errors: dataset not built",false);
    }

    this.props.report.errors   = rpt_errors;
    this.props.report.warnings = rpt_warnings;
    this.props.report.layers   = rpt_layer;
    this.props.report.depths   = rpt_depth;
    this.props.report.wells    = rpt_wells;

    this.props.report.go = true;

    this.props.trigger();
  }

  getpara(sixxc,sixc,num,ipara,type)
  {
    return this.getparax(sixxc,sixc,num,ipara,type,false);
  }

  getparax(sixxc,sixc,num,ipara,type,qbase)
  {
    if ( typeof sixxc[num]==='undefined' )
    {
      global.alertx("get para problem",true);
    }

    var qdollar=false;
    if ( typeof this.sens.string!=='undefined' && !qbase )
    {
      if ( this.sens.sixxc.name===sixc && this.sens.num===num && this.sens.para===ipara ) qdollar=true;
    }

    if ( typeof sixxc[num].para==='undefined' || typeof sixxc[num]==='undefined' || typeof type==='undefined' )
    {
      global.alertx(" attempting to use a parameter of an imported object",true);
    }

    if      ( qdollar        ) return '$A';
    else if ( type==='int'   ) return parseInt(sixxc[num].para[ipara].value);
    else if ( type==='float' ) return parseFloat(sixxc[num].para[ipara].value);
    else                       return sixxc[num].para[ipara].value;
  }

  getsection(data,sect,sel) // Note, this guy makes a copy
  {
    var ret = this.copyobj(data[sect][sel].data);
    for ( var i=0; i<global.common.structure.sections[sect].sixcs.length; i++ )
    {
      var sixc = global.common.structure.sections[sect].sixcs[i].name;
      ret[sixc].sixc = sixc;
    }
    return ret;
  }

  getparat(sixc,item,para,type)
  {
    var sect = global.common.sixxcs[sixc].sect;
    var sectfile = '';
  
    for ( var i=0; i<global.common.listsect.length; i++ )
    {
      if ( sect===global.common.listsect[i] )
      {
        sectfile = this.data['build'][this.file].data[this.props.sixxc][0].para[i].value;
        break;
      }
    }
    var ret = '';

    if ( sectfile==='' ) ;
    else if ( type==='name' ) ret = this.data[sect][sectfile].data[sixc][item].name;
    else if ( type==='type' ) ret = this.data[sect][sectfile].data[sixc][item].type;
    else if ( type==='data' ) ret = this.data[sect][sectfile].data[sixc][item].data;
    else if ( type==='len'  ) ret = this.data[sect][sectfile].data[sixc].length;
    else if ( type==='obj'  ) ret = this.data[sect][sectfile].data[sixc];
    else if ( type==='nobj' ) ret = this.data[sect][sectfile].data[sixc][item];
    else                      ret = this.getparax(this.data[sect][sectfile].data[sixc],sixc,item,para,type,false);

    return ret;
  }

  getbaseparat(sixc,item,para,type)
  {
    var sect = global.common.sixxcs[sixc].sect;
    var sectfile = '';
  
    for ( var i=0; i<global.common.listsect.length; i++ )
    {
      if ( sect===global.common.listsect[i] ) 
      {
        sectfile = this.data['build'][this.file].data[this.props.sixxc][0].para[i].value;
        break;
      }
    }
    var ret = this.getparax(this.data[sect][sectfile].data[sixc],sixc,item,para,type,true);

    return ret;
  }

  getcalc()
  {
    var eqn=''; 
    if ( this.sens.sixxc.name==='geomech' && this.sens.para===3 )
    {
      eqn = '$D = $A*'+this.build['constants'].rockcfact.value;
    }
    if ( this.sens.sixxc.name==='geomech' && this.sens.para===2 )
    {
      eqn = '$D = $A*'+this.build['constants'].sigprop.value;
    }
    return eqn;
  }

  usecalc(calc,is)
  {
    var value=''; 
    if ( calc==='compred')
    {
      if ( typeof this.sens.string!=='undefined' && this.sens.sixxc.name==='geomech' && this.sens.num===is && this.sens.para===3 )
      {
        value = '$D';
      }
      else 
      {
        value = this.getparat('geomech',is,3,'float')*this.build['constants'].rockcfact.value;
      }
    } 
    else if ( calc==='sigp' )
    {
      if ( typeof this.sens.string!=='undefined' && this.sens.sixxc.name==='geomech' && this.sens.num===is && this.sens.para===2 )
      {
        value = '$D';
      }
      else 
      {
        value = this.getparat('geomech',is,2,'float')*this.build['constants'].sigprop.value;
      }
    } 
    else global.alertx('usecalc called in error',true);

    return value; 
  }

  checkexists(data,name)
  {
    var ret = -1;
    for ( var j=0; j<data.length; j++ )
    {
      if ( name===data[j].name )
      {
        ret = j;
        break;
      }
    }
    return ret;
  }

  checkexistst(sixc,name)
  {
    var sect = global.common.sixxcs[sixc].sect;
    var sectfile = '';
  
    for ( var i=0; i<global.common.listsect.length; i++ )
    {
      if ( sect===global.common.listsect[i] )
      {
        sectfile = this.data['build'][this.file].data[this.props.sixxc][0].para[i].value;
        break;
      }
    }

    var ret = -1;
    for ( var j=0; j<this.data[sect][sectfile].data[sixc].length; j++ )
    {
      if ( name===this.data[sect][sectfile].data[sixc][j].name )
      {
        ret = j;
        break;
      }
    }
    return ret;
  }

  selected(data) 
  {
    var s = this.selecteddata(data);
    var r = s.data.revision.rev;
    return s.name+'('+r+')';
  }

  getmeta(data) 
  {
    var s = this.selecteddata(data);
    var r = s.data.revision.rev;
    return { name: s.name, rev: r };
  }

  selecteddata(data) 
  {
    var sel = 0;
    if ( typeof this.props.selected[data]!=='undefined' ) sel = this.props.selected[data];

    return global.common.data[data][sel];
  }

  builddeck(sixxc,wellsused,rpt_warnings)
  {
    var data = global.common.data;

    if ( data.build[0].data[sixxc].length===0 ) this.props.handleNewitem('run'); // Acts like "add", but only "one"
    else                                        this.props.submit();

    var file = 0; if ( typeof this.props.selected['build']!=='undefined' && 
                              this.props.selected['build']<data['build'].length) file = this.props.selected['build'];

    if ( sixxc==='sensitivity' )
    {
      global.alertx('MR run',false);
      global.common.data['build'][file].mr = true;
    }
    else
    {
      global.common.data['build'][file].mr = false;
    }

    var qstresssol = this.getparat('stresssol',0,4,'int')===1;

    var u = new Units();
    var dataset = '';
    const pi = Math.PI;
    const ndim=21;
    const epsdep=1e-3; // Depth epsilon to avoid wells hitting cell boundaried exactly
    var nzf=0;
    for ( var ilay=0; ilay<this.getparat('layer',0,0,'len'); ilay++ )
    {
      nzf += this.getparat('layer',ilay,3,'float');
    }
    if ( qstresssol && this.getparat('stresssol',0,3,'double')>0 ) nzf += 2*this.overburdenlayers();

    var nz = nzf*2; // dual poro

    var jsonwell={};
    var sectnames =  Object.keys(global.common.structure.sections);    
    const selected = sectnames.map((data) => this.selected(data) );
    const meta = sectnames.map((data) => this.getmeta(data) );
    var metadata={};
    for ( var i=0; i<meta.length; i++ )
    {
      metadata[sectnames[i]]=meta[i];
    }

    var trimpl=2; if ( qstresssol ) trimpl = 0; // 6X can't handle implicit tracer + stress solve.

    // Preamble
    dataset += '--RKS -allow_zero_perm 1 -trmin_static 1e-20 -trmimpl '+trimpl+' -lstol 1e-4 -prop_gamma 1 -prop_trap_full 1 \n';
    dataset += '--RKS -sumout 2 -sumlong 1 -wout 1 \n\n';

    if ( sixxc==='sensitivity' ) 
    {
      var pmn = this.build[sixxc][0].para.length-3;
      var pmx = this.build[sixxc][0].para.length-2;
      var pnm = this.build[sixxc][0].para.length-1;
      var parasens = this.props.sensitivities();
      this.sens = parasens[this.props.sensselected];
      var base = parasens[this.props.sensselected].value;
      var ncases = parseInt(this.build[sixxc][0].para[pnm].value);
      var cases = new Array(ncases);
      var vmax = parseFloat(this.build[sixxc][0].para[pmx].value[this.props.sensselected]);
      var vmin = parseFloat(this.build[sixxc][0].para[pmn].value[this.props.sensselected]);
      var dvar = (vmax-vmin)/(ncases-1);
      cases[0] = vmin;
      for ( var ic=1; ic<ncases; ic++ )
      {
        cases[ic] = cases[ic-1]+dvar;
      }
      dataset = this.mrhead(dataset,base,cases);
    }
    else 
    {
      this.sens={};
    }
    var uset = u.set[global.common.data.options.units].toUpperCase();

    dataset += 'RUNSPEC \n\n';
    dataset += 'TITLE \n 6Xapp selected: ';
    for ( i=0; i<selected.length; i++ ) dataset += selected[i]+' ';
    dataset += '\n\n'
    dataset += 'DIMENS\n '+ndim+' '+ndim+' '+nz+' /\n\n';
    dataset += 'OIL\nWATER\nGAS\nDISGAS\n\n';
    dataset += uset+'\n\n';
    dataset += 'DUALPORO\n\n';
    if ( qstresssol ) dataset += 'GEOMECH\n  4  no   / \n\n';
    var sdate = this.startdate.getDate()+' '+global.common.months[this.startdate.getMonth()]+' '+this.startdate.getFullYear();
    dataset += 'START\n '+sdate+' / \n\n';
    dataset += 'GRID\n\n';

    // Orientation

    if ( this.getbaseparat('stress',0,3,'float')>1e-6 )
    {
      var rot = 2*pi*this.getbaseparat('stress',0,3,'float')/360;
      var a00 = Math.cos(rot); var a01 = -Math.sin(rot);
      var a10 = Math.sin(rot); var a11 =  Math.cos(rot);

      dataset += 'MAPAXES\n';
      dataset += '  '+a01+' '+a11+'   0 0   '+a00+' '+a11+'   /\n\n';
    }

    // Refinement 

    var nrefine =  this.getparat('formation',0,2,'int');
    if ( nrefine>0 ) 
    {
      var limit = Math.max(5-nrefine,1);
      dataset += 'RKSNESTCW\n  *  '+limit+'  '+nrefine+' /\n /\n\n'

      dataset += 'RKSNESTCOPTS\n  0  /\n\n'
    }

    // Areal dimensions

    var xmin= 100000000; var ymin= 100000000;
    var xmax=-100000000; var ymax=-100000000;
    var lmax=-1000000;

    var rksjson={ wells: [] };
    var simwelldep = [];

    var nparent=0;
    for ( i=0; i<this.getparat('well',0,0,'len'); i++ )
    {
      if      ( this.getparat('well',i,0,'type')==='imported'          ) nparent++;
      else if ( this.getbaseparat('well',i,6,'').toUpperCase()==='YES' ) nparent++;
    }

    var welllimits = [];
    var nimport=0;
    for ( i=0; i<this.getparat('well',0,0,'len'); i++ )
    {
      if ( this.getparat('well',i,0,'type')==='simple' )
      {
        var len = this.getbaseparat('well',i,1,'float');
        var x0  = this.getbaseparat('well',i,3,'float');
        var y0  = this.getbaseparat('well',i,4,'float');
        var rt  = 2*pi*(this.getbaseparat('well',i,2,'float')-this.getbaseparat('stress',0,3,'float'))/360;
        var rd  = 2*pi*this.getbaseparat('well',i,5,'float')/360;
        var lenxy = len*Math.sin(rd);
        var x1 = x0 + Math.cos(rt)*lenxy;
        var y1 = y0 + Math.sin(rt)*lenxy;
        var qparent = this.getbaseparat('well',i,6,'').toUpperCase()==='YES';

        var limits={ parent: qparent||nparent===0, x0: x0, y0: y0, x1: x1, y1:y1 };
        if ( qparent || nparent===0 )
        {
          xmin = Math.min(xmin,x0); ymin = Math.min(ymin,y0);
          xmin = Math.min(xmin,x1); ymin = Math.min(ymin,y1);
          xmax = Math.max(xmax,x0); ymax = Math.max(ymax,y0);
          xmax = Math.max(xmax,x1); ymax = Math.max(ymax,y1);

          lmax = Math.max(lmax,len);
        }

        var fracs = this.getfracs(this.getparat('schedule',0,0,'obj'),this.getparat('well',i,0,'name'));
      
        jsonwell = this.addsimplewell(i,fracs);
        simwelldep.push(this.getparat('well',i,0,'float'));
      }
      else 
      { 

        //
        // add a simple frac to an imported well
        //
        if ( !global.common.data.options.completions )
        {
          for ( var isched=0; isched<this.getparat('schedule',0,0,'len'); isched++ )
          {
            var iwell = this.getindex(this.getparat('well',0,0,'obj'      ),this.getparat('schedule',isched,0,'')); 
            var ifrac = this.getindex(this.getparat('frac',0,0,'obj'      ),this.getparat('schedule',isched,1,'')); 
            if ( iwell>=0 && ifrac>=0 & i===iwell )
            {
              this.addsimplefrac(isched,this.getparat('well',i,0,'nobj'));
            }
          }
        }

        if ( wellsused[this.getparat('well',i,0,'name')]>0 ) nimport++;
        jsonwell = this.copyobj(this.getparat('well',i,0,'nobj'));
        rot = 2*pi*this.getbaseparat('stress',0,3,'float')/360;
        a00 = Math.cos(rot); a01 = -Math.sin(rot);
        a10 = Math.sin(rot); a11 =  Math.cos(rot);

        var xmin1= 100000000; var ymin1= 100000000;
        var xmax1=-100000000; var ymax1=-100000000;


        limits={ parent: true };

        for ( var iwt=0; iwt<jsonwell.x.length; iwt++ )
        {
          var x = a00*jsonwell.x[iwt] + a01*jsonwell.y[iwt];
          var y = a10*jsonwell.x[iwt] + a11*jsonwell.y[iwt];
          jsonwell.x[iwt] = x;
          jsonwell.y[iwt] = y;
          
          xmin = Math.min(xmin,jsonwell.x[iwt]); ymin = Math.min(ymin,jsonwell.y[iwt]); // all wells
          xmax = Math.max(xmax,jsonwell.x[iwt]); ymax = Math.max(ymax,jsonwell.y[iwt]);

          xmin1 = Math.min(xmin1,jsonwell.x[iwt]); ymin1 = Math.min(ymin1,jsonwell.y[iwt]); // one well
          xmax1 = Math.max(xmax1,jsonwell.x[iwt]); ymax1 = Math.max(ymax1,jsonwell.y[iwt]);
        }
        len = Math.sqrt((xmax1-xmin1)*(xmax1-xmin1)+(ymax1-ymin1)*(ymax1-ymin1));
        lmax = Math.max(lmax,len);

        delete jsonwell.type;
        delete jsonwell.prnt;
        delete jsonwell.para;
        if ( nimport===1 ) { global.alertx("  using imported well(s)",false); nimport++ }
      }
      welllimits.push(limits);
      if ( wellsused[this.getparat('well',i,0,'name')]>0 ) rksjson.wells.push(jsonwell);
    }

    var extent = this.getbaseparat('formation',0,5,'float');

    lmax = Math.max(extent*lmax,extent*this.build['constants'].extent.value); // min 40 acre spacing 

    xmin -= lmax; ymin -= lmax;  
    xmax += lmax; ymax += lmax;

    ymin += 1; ymax +=1; // Aimed to prevent default wells hitting a gridblock boundary exactly and hence getting 2 connections
    xmin += 1; xmax +=1;

    //
    // Check wells are inside the grid 
    //
    for ( i=welllimits.length-1; i>=0; i-- )
    {
      if ( !welllimits[i].parent )
      {
        if ( welllimits[i].x0<xmin || welllimits[i].y0<ymin || welllimits[i].x1>xmax || welllimits[i].y1>ymax ) 
        {
          rpt_warnings.push(' well '+rksjson.wells[i].name+' lies outside the grid');
          rksjson.wells.splice(i,1);
        }
      }
    }

    dataset += 'RKSSETCOORD\n '+xmin+' '+ymin+'  '+xmax+' '+ymax+' / \n\n';

    var dzs = this.getparat('layer',0,0,'obj').map((data,index) => this.layerorder(data,index) );
    dzs.sort( function(a,b) { return a.order-b.order } );

    var nline=20;
    var top = this.getparat('formation',0,0,'float');
    var bottom = top;
    for ( i=0; i<this.getparat('layer',0,0,'len'); i++ ) bottom += dzs[i].dz;

    var dipo = this.getparat('dip',0,0,'obj');
    var dip  = dipo[0].para[2].value;
    var qlogs = typeof this.getparat('formation',0,0,'obj').logs !== 'undefined';

    if ( Math.abs(dip)>1e-6 && qlogs ) global.alertx(' dip will be ignored as logs have been specified');
    var qdip = false;

    if ( Math.abs(dip)>1e-6 && !qlogs )
    {
      var dzt=0;
      if ( qstresssol && this.getparat('stresssol',0,3,'double')>0 )
      {
        var dztot=0;
        for ( i=0; i<this.getparat('layer',0,0,'len'); i++ ) dztot += dzs[i].dz;

        var nex = this.overburdenlayers();
        var dz = dztot/this.getparat('layer',0,0,'len');
        dzt = dz;

        for ( i=1; i<nex; i++ ) { dz = 2*dz; dzt += dz; }
      }
      qdip = true;
      var zmm = top - dzt + this.calcz(dipo[0].para,xmin,ymin);
      var zmx = top - dzt + this.calcz(dipo[0].para,xmin,ymax);
      var zxm = top - dzt + this.calcz(dipo[0].para,xmax,ymin);
      var zxx = top - dzt + this.calcz(dipo[0].para,xmax,ymax);
      var dx = xmax-xmin;
      var dy = ymax-ymin;
      dataset += 'RKSMAP\n TOPS  1 '+xmin+' '+ymin+'   '+dx+' '+dy+'   2 2 / \n ';
      dataset += '  '+zmm+' '+zxm+' '+zmx+' '+zxx+' / \n / \n\n';
    }
    else
    {
      dataset += 'RKSKRIGE\n ZCORN  / \n ';
      var nwz = 1;
      if ( qlogs ) nwz = this.getparat('well',0,0,'len');

      for ( var iw=0; iw<nwz; iw++ )
      {
        var iline=0;
        var dep = top;
        var xloc = 0;
        var yloc = 0;
        if ( this.getparat('well',iw,0,'type')==='simple' )
        {
          xloc = this.getparat('well',iw,3,'float');
          yloc = this.getparat('well',iw,4,'float');
        }
        else
        {
          xloc = this.getparat('well',iw,0,'nobj').x[0];
          yloc = this.getparat('well',iw,0,'nobj').y[0];
        }

        if ( qlogs ) dep = parseFloat(this.getpparat('formation',0,0,'obj').logs.thick[0][iw+1]);

        //
        // Over-burden - stress solve only if extended
        //
        if ( qstresssol && this.getparat('stresssol',0,3,'double')>0 )
        {
          dz = this.overburdenthickness(dzs);

          for ( i=0; i<dz.length; i++ ) dep -= dz[i];

          dataset += ' '+xloc+' '+yloc+'  '+dep+' ';

          for ( i=dz.length-1; i>=0; i-- ) 
          { 
            dep += dz[i];
            dataset += dep+' ';
          } 
        }
        else // end qstressol
        {
          dataset += ' '+xloc+' '+yloc+'  '+dep+' ';
        }

        for ( i=0; i<this.getparat('layer',0,0,'len'); i++ ) 
        {
          var nsublayers = this.getparat('layer',i,3,'int');
          var thick = dzs[i].dz;

          if ( qlogs ) thick = parseFloat(this.getparat('formation',0,0,'obj').logs.thick[i+1][iw+1]);

          for ( var j=0; j<nsublayers; j++ )
          {
            dep += thick/nsublayers;
            for ( var k=0; k<simwelldep.length; k++ )
            {
              if ( Math.abs(dep-simwelldep[k])<epsdep ) dep += epsdep;
            }
            dataset += dep+' ';
            iline++;
            if ( iline===nline ) { iline=0; dataset += '\n'; }
          }
        }
        
        //
        // Under-burden - stress solve only if extended
        //
        if ( qstresssol && this.getparat('stresssol',0,3,'double')>0 )
        {
          for ( i=0; i<dz.length; i++ ) 
          { 
            dep += dz[i];
            dataset += dep+' ';
          } 
        }

        dataset += ' / \n ';
      }
      dataset += '  / \n\n';
    }

    dataset += 'NODPPM\n\n ';

    this.getparat('layer',0,0,'obj').sort( function(a,b) { return a.para[0].value-b.para[0].value } );

    dataset += '-- matrix (first half) \n';
    dataset += 'EQUALS\n';

    dataset += this.rocklayers(dzs,nzf,true,qdip,qstresssol);

    dataset += ' / \n\n-- fracture (second half) \n';
    dataset += 'EQUALS\n';

    dataset += this.rocklayers(dzs,nzf,false,qdip,qstresssol);

    // all cells
    dataset += ' / \n\n';
    dataset += 'EQUALS\n';
    dataset += ' RKSFRACROUGH  -1  4*  1 '+nz+' / \n'; 
    dataset += ' / \n\n';

    // poro/perm fom logs
    if ( typeof this.getparat('formation',0,0,'obj').logs !== 'undefined' )
    {
      for ( var iprop=0; iprop<2; iprop++ )
      {
        if ( iprop===0 ) dataset += 'RKSKRIGE\n PORO  / \n ';
        if ( iprop===1 ) dataset += 'RKSKRIGE\n PERMX  / \n ';
        for ( iw=0; iw<this.getparat('well',0,0,'len'); iw++ )
        {
          iline = 0;
          xloc = this.getparat('well',iw,3,'float');
          yloc = this.getparat('well',iw,4,'float');

          dataset += ' '+xloc+' '+yloc+'  ';
          for ( ilay=0; ilay<this.getparat('well',0,0,'len'); ilay++ ) 
          {
            nsublayers = this.getparat('layer',ilay,3,'int');

            var              value = parseFloat(this.getparat('formation',0,0,'obj').logs.porosity[ilay][iw+1]);
            if ( iprop===1 ) value = parseFloat(this.getparat('formation',0,0,'obj').logs.permeability[ilay][iw+1]);

            if ( nsublayers>1 ) dataset += nsublayers+'*'+value+' ';
            else                dataset += value+' ';

            iline++;
            if ( iline===nline ) { iline=0; dataset += '\n'; }
          }
          for ( ilay=0; ilay<this.getparat('layer',0,0,'len'); ilay++ ) 
          {
            nsublayers = this.getparat('layer',ilay,3,'int');

            var ffrac  = this.build['constants'].ffrac.value;
                             value = ffrac*parseFloat(this.getparat('formation',0,0,'obj').logs.porosity[ilay][iw+1]);
            if ( iprop===1 ) value = parseFloat(this.getparat('formation',0,0,'obj').logs.permeability[ilay][iw+1]);

            if ( nsublayers>1 ) dataset += nsublayers+'*'+value+' ';
            else                dataset += value+' ';

            iline++;
            if ( iline===nline ) { iline=0; dataset += '\n'; }
          }
          dataset += ' / \n ';
        }
        dataset += '  / \n\n';
      }
    }


    dataset += 'COPY\n PERMX PERMY / \n PERMX PERMZ /\n /\n\n';
    dataset += 'PROPS\n\n';
 
    for ( var is=0; is<this.getparat('geomech',0,0,'len'); is++ ) 
    {
      var is1 = is+1;
      var depl    = this.build['constants'].depleat.value;
      var stimres = this.getparat('geomech',is,4,'float')/100;
      var stim    = -Math.log(Math.max(stimres,1e-14))/depl;
      var propres = this.getparat('geomech',is,5,'float')/100;
      var prop    = -Math.log(Math.max(propres,1e-14))/depl;
      var sig  = this.build['constants'].sigmacomp.value;
      var sigp = this.usecalc('sigp',is);
      dataset += 'RKSPMODTAB '+is1+' 2D2  \n  STIMULATED   '+stim+' '+stim+' '+stim+' '+sig+'  \n';
      dataset +=                          '  PROPPED      '+prop+' '+prop+' '+prop+' '+sig+'  '+sigp+' \n';
      dataset += '  '+this.build['constants'].negstressb.value+'     '+this.getparat('geomech',is,1,'float')+'        '+this.getparat('geomech',is,2,'float')+' \n';
      if ( this.getparat('geomech',is,0,'float')>0.0 || this.getparat('geomech',is,0,'float')==='$A' ) 
      dataset += '    -'+this.getparat('geomech',is,0,'float')+'        0        0 \n';
      dataset += '    0.0        0        0 \n';
      dataset += ' / \n\n';

      var compinc = this.getparat('geomech',is,3,'float');
      var fraccmp = this.build['constants'].fraccomp.value;
      var compred = this.usecalc('compred',is);
      dataset += 'RKSROCKCTAB '+is1+' STR  \n';
      dataset += '   '+this.build['constants'].negstressb.value+'  '+this.build['constants'].negstressl.value+'  0  '+this.build['constants'].posstress.value+'\n';
      dataset += '     '+compred+'   '+compred+'   '+fraccmp+'   '+fraccmp+' \n';
      dataset += '     '+compinc+'   '+compinc+'   '+fraccmp+'   '+fraccmp+' \n';
      dataset += ' / \n\n';
    }
    var frockc = this.getparat('geomech',0,0,'len')+1; 
    dataset += 'RKSROCKCTAB '+frockc+' STR  \n';
    dataset += '   '+this.build['constants'].negstressb.value+'  '+this.build['constants'].negstressl.value+'  0  '+this.build['constants'].posstress.value+'\n';
    dataset += '   '+this.build['constants'].matcomp.value+'  '+this.build['constants'].matcomp.value+'  '+this.build['constants'].matcomp.value+'   '+this.build['constants'].matcomp.value+' \n';
    dataset += '   '+this.build['constants'].matcomp.value+'  '+this.build['constants'].matcomp.value+'  '+this.build['constants'].matcomp.value+'   '+this.build['constants'].matcomp.value+' \n';
    dataset += ' / \n\n';

    dataset += 'SWLET \n   2 2 1   5 5 3   5 0 2  / \n '
    dataset += '  1 1 1   0 0 0   0 0 0  / \n /\n\n'
    dataset += 'SGLET \n   2 2 1   5 5 3   5 0 2  / \n '
    dataset += '  1 1 1   0 0 0   0 0 0  / \n /\n\n'
    dataset += 'SOLET \n   2 2 1   2 2 1  / \n '
    dataset += '  1 1 1   1 1 1  / \n /\n\n'

    dataset += this.pvt(this.getparat('fluid',0,0,'data'));

    var tracers = [];

    for ( isched=0; isched<this.getparat('schedule',0,0,'len'); isched++ )
    {
      var well = this.getparat('schedule',isched,0,''); 
      var frac = this.getparat('schedule',isched,1,'');
      var ifrc = 0; 
      var stge = 0;
      if( global.common.data.options.completions ) 
      {
        ifrc = this.getindex(this.getparat('completion',0,0,'obj'),frac); 
        stge = this.getparat('completion',ifrc,3,'');
      }
      else
      {
        ifrc = this.getindex(this.getparat('frac',0,0,'obj'),frac); 
        stge = this.getparat('frac',ifrc,3,'');
      }
      var istg = this.getindex(this.getparat('stages',0,0,'obj'),stge); 
      if ( istg>=0 )
      {
        var iinj = this.getindex(this.getparat('injfluid',0,0,'obj'),this.getparat('stages',istg,3,''));
        var name = this.getparat('injfluid',0,0,'name');
        var visc = this.getparat('injfluid',iinj,0,'float');
            prop = this.getparat('injfluid',iinj,1,'');
        var iprp = this.getindex(this.getparat('proppant',0,0,'obj'),prop);
        if ( name!=='water' || Math.abs(visc-1)>1e-3 )
        {
          tracers.push({name: name, well: well, visc: visc, type: 'G'});
        }
        if ( prop!=='none' && prop!=='' )
        {
          var diam = this.getparat('proppant',iprp,0,'float');
          var rho  = this.getparat('proppant',iprp,1,'float');
          var conc = this.getparat('proppant',iprp,2,'float');
          var vel  = this.getparat('proppant',iprp,3,'float');
          tracers.push({name: name, well: well, visc: visc, type: 'P', diam: diam, rho: rho, conc: conc, vel:vel });
        }
        break;
      }
    }

    if ( tracers.length>0 )
    {
      var ngel = 0;
      dataset += 'RKSTRACERS \n';
      for ( i=0; i<tracers.length; i++ )
      {
        dataset += '  '+tracers[i].type+tracers[i].name+'  liquid  no / \n';
        if ( tracers[i].type==='G' ) ngel++;
      }
      dataset += '/ \n\n';

      if ( ngel )
      {
        dataset += 'RKSGELS \n';
        for ( i=0; i<tracers.length; i++ )
        {
          if ( tracers[i].type==='G' )
          {
            dataset += '  '+tracers[i].name+'_gel  '+tracers[i].type+tracers[i].name+'  14.7 '+tracers[i].visc+' / \n';
          }
        }
        dataset += '/ \n\n';
      }

      dataset += 'RKSPROPPANTS \n';
      for ( i=0; i<tracers.length; i++ )
      {
        if ( tracers[i].type==='P' )
        {
          var tval='  ';
          if ( tracers[i].vel>=0.0 ) tval += tracers[i].vel;
          dataset += '  '+tracers[i].name+'_prop  '+tracers[i].type+tracers[i].name+'  '+
                         this.build['constants'].partden.value+'  '+tracers[i].rho+'  '+tracers[i].diam+' '+tval+'  \n';
        }
      }
      dataset += '/ \n\n';
    }

    dataset += 'SOLUTION\n\n';

    var refdep = top; 
    if ( simwelldep.length>0 ) refdep=simwelldep[0]; // first simple well
    var goc = top-100; 
    var owc = bottom+200; 
    if ( this.getparat('formation',0,3,'')!=='' ) goc = this.getparat('formation',0,3,'float');
    if ( this.getparat('formation',0,4,'')!=='' ) owc = this.getparat('formation',0,4,'float');
    var rpres = this.getparat('formation',0,1,'float');
    dataset += 'EQUIL\n  '+refdep+' '+rpres+' '+owc+'  0 '+goc+' 0  1   /  \n / \n\n';

    var pbub = this.getparat('fluid',0,0,'float');
    dataset += 'PBVD\n  '+top+' '+pbub+' \n  '+bottom+' '+pbub+' / \n\n';

    for ( i=0; i<tracers.length; i++ )
    {
      dataset += 'RKSTRCONCVD  '+tracers[i].type+tracers[i].name+'  \n';
      dataset += '  '+top+'  0.0  \n'
      dataset += '  '+bottom+'  0.0  \n / \n\n'
    }

    if ( global.common.data.options.completions )
    {
      dataset += 'SUMMARY\n\n';
      dataset += 'RKSRPTSRV\n  TMFMOD  1.0001 / \n\n';
    }

    dataset += 'SCHEDULE\n\n';

    var awells={};
    for ( isched=0; isched<this.getparat('schedule',0,0,'len'); isched++ )
    {
      awells[this.getparat('schedule',isched,0,'')]=isched;
    }
    var nawells = Object.keys(awells).length;
    
    var qcomps=global.common.data.options.rkscomp;
    if      ( !qcomps )   dataset += '--RKSCOMPS\n--  * / \n\n';
    else if ( nawells>1 ) dataset += 'RKSCOMPSMIN\n  * / \n\n';
    else                  dataset += 'RKSCOMPS\n  * / \n\n';
    dataset += 'WPAVE\n    / \n\n';

    var srksjson = JSON.stringify(rksjson, null, ' ');
    dataset += 'RKSJSON\n';
    dataset += srksjson;
    dataset += '\n  / \n\n';


    if ( tracers.length>0 )
    {
      dataset += 'RKSWTRCONC  \n';
      for ( i=0; i<tracers.length; i++ )
      {

        if ( tracers[i].type==='G' )
        {
          dataset += '  '+tracers[i].well+'  ' +tracers[i].type+tracers[i].name+'  1.0  / \n';
        }
        else if ( tracers[i].type==='P' )
        {
          dataset += '  '+tracers[i].well+'  ' +tracers[i].type+tracers[i].name+'  '+tracers[i].conc+'  / \n';
        }
      }
      dataset += ' / \n\n';
    }

    var allevents = [];

    if ( global.common.data.options.completions )
    {
      var keyword = 'RKSWORKOVER\n '
      keyword += '  *  *  SHUT  / \n /\n\n';
      allevents.push({ time: this.startdate.getTime(), keyword: keyword });
    }

    for ( isched=0; isched<this.getparat('schedule',0,0,'len'); isched++ )
    {
          iwell = this.getindex(this.getparat('well',0,0,'obj'      ),this.getparat('schedule',isched,0,'')); 
          ifrac = this.getindex(this.getparat('frac',0,0,'obj'      ),this.getparat('schedule',isched,1,'')); 
      var icomp = this.getindex(this.getparat('completion',0,0,'obj'),this.getparat('schedule',isched,1,'')); 
      if ( iwell>=0 && (ifrac>=0||icomp>=0))
      {
        var stages = this.getparat('schedule',isched,2,'');

        if ( global.common.data.options.completions )
        {
          well       = this.getparat('schedule',isched,0,'');
          var comp   = this.getparat('schedule',isched,1,'');
          var start  = this.getparat('schedule',isched,3,'float');
          var status = this.getparat('schedule',isched,5,'');
          var ustatus = status.toUpperCase();
          var qopen = ustatus.substr(0,1)!=='C';

          if ( stages!=='' ) 
          {
            var events = this.addsinglestage(isched);
            for ( var iev=0; iev<events.length; iev++ )
            {
              allevents.push(events[iev]);
            }
          }
          else 
          {
            events = this.openclose(well,comp,start,qopen);
            for ( iev=0; iev<events.length; iev++ )
            {
              allevents.push(events[iev]);
            }
          }
        }
        else
        {
          events = this.addmultistage(isched,rksjson);
          for ( iev=0; iev<events.length; iev++ )
          {
            allevents.push(events[iev]);
          }

          //
          // Production
          //
          var iprod  = this.getindex(this.getparat('production',0,0,'obj' ),this.getparat('schedule',isched,3,'')); 
          well       = this.getparat('schedule',isched,0,'');
          var pstart = this.getparat('schedule',isched,4,'float');

          if ( iprod>=0 )
          {
            events = this.addproduction(iprod,well,pstart);
            for ( iev=0; iev<events.length; iev++ )
            {
              allevents.push(events[iev]);
            }

            events = this.endproduction(iprod,well,pstart);
            for ( iev=0; iev<events.length; iev++ )
            {
              allevents.push(events[iev]);
            }
          }
        }
      }
    }

    allevents.sort( function(a,b) { return a.time-b.time } );

    //
    // Check for duplicate dates, else 6X stops
    //
    var lastdate=-1;
    var toberemoved=[];
    for ( i=0; i<allevents.length; i++ )
    {
      if ( allevents[i].keyword.substring(0,5)==='DATES' )
      {
        if ( Math.abs(lastdate-allevents[i].time)<1000 )
        {
          toberemoved.push(i);
        }
        lastdate = allevents[i].time;
      }
    }
    for ( i=toberemoved.length-1; i>=0; i-- ) allevents.splice(toberemoved[i],1);

    for ( iev=0; iev<allevents.length; iev++ )
    {
      dataset += allevents[iev].keyword;
    }

    dataset += 'END\n';

    this.props.report.text = dataset;
    this.props.report.go = false;

    file = 0; if ( typeof this.props.selected['build']!='undefined' && 
                          this.props.selected['build']<global.common.data['build'].length) file = this.props.selected['build'];
    global.common.data['build'][file].dataset = dataset;
    global.common.data['build'][file].metadata = metadata;

    this.props.trigger();

  }

  rocklayers(dzs,nzf,qmat,qdip,qstresssol)
  {
    var ima=1;
    var dataset='';

    var rockcfrac = this.getparat('geomech',0,0,'len')+1;
    var satnfrac  = this.getparat('scal',0,0,'len')+1;

    //
    // overburden - same as layer 0
    //
    if ( qstresssol && this.getparat('stresssol',0,3,'double')>0 )
    {
      var n = this.overburdenlayers();

      dataset += '\n-- Added Overburden '+n+' layers - logarithmic grid  \n';
      var imb = ima+n-1;
      var ifr = ima+nzf;
      var ifb = ifr+n-1;

      var rock = this.getparat('layer',0,2,'');
      var rk  = this.getrockprops(this.getparat('rock',0,0,'obj'),rock);
      var pp  = this.getporoperm(this.getparat('poroperm',0,0,'obj'),rk.poroperm);
      var gm  = this.getindex(this.getparat('geomech',0,0,'obj'),rk.geomech)+1; // 1-based adressing
      var scl = this.getindex(this.getparat('scal',0,0,'obj'),rk.scal);
      var sts = this.getstress(this.getparat('stress',0,0,'obj'));
      var gms = -1; if ( qstresssol ) gms += gm;

      var sigma = this.build['constants'].sigma.value;

      var ffrac = this.build['constants'].ffrac.value;

      if ( qdip )
      {
        var dz = this.overburdenthickness(dzs);

        var imu = ima;
        var ifu = ifr;
        for ( var i=dz.length-1; i>=0; i-- ) 
        { 
          if (  qmat ) dataset += ' DZ  '+dz[i]+'  4*  '+imu+' '+imu+' / \n';
          if ( !qmat ) dataset += ' DZ  '+dz[i]+'  4*  '+ifu+' '+ifu+' / \n';

          if (  qmat ) dataset += this.matlayer(imu,imu,scl,sts,rockcfrac,pp.poro*(1-ffrac),pp.perm,sigma,false,gms);
          if ( !qmat ) 
          {
            var fporo = Math.max(pp.poro*ffrac,this.build['constants'].minfporo.value);
            dataset += this.fraclayer(ifu,ifu,satnfrac,sts,gm,fporo,pp.perm,gms);
          }
          imu++; ifu++;
        }
      }
      else
      {
        if (  qmat ) dataset += this.matlayer(ima,imb,scl,sts,rockcfrac,pp.poro*(1-ffrac),pp.perm,sigma,false,gms);
        if ( !qmat ) 
        {
          fporo = Math.max(pp.poro*ffrac,this.build['constants'].minfporo.value);
          dataset += this.fraclayer(ifr,ifb,satnfrac,sts,gm,fporo,pp.perm,gms);
        }
      }

      ima += n;
    }

    for ( i=0; i<this.getparat('layer',0,0,'len'); i++ )
    {
      var nsublayers = this.getparat('layer',i,3,'int');
      var th = dzs[i].dz/nsublayers;

      var ii=i+1;
      dataset += '\n-- Layer '+ii+' sub-layers '+nsublayers+' \n';
      imb = ima+nsublayers-1;
      ifr = ima+nzf;
      ifb = ifr+nsublayers-1;

      rock = this.getparat('layer',i,2,'');
      rk  = this.getrockprops(this.getparat('rock',0,0,'obj'),rock);
      pp  = this.getporoperm(this.getparat('poroperm',0,0,'obj'),rk.poroperm);
      gm  = this.getindex(this.getparat('geomech',0,0,'obj'),rk.geomech)+1; // 1-based adressing
      scl = this.getindex(this.getparat('scal',0,0,'obj'),rk.scal);
      sts = this.getstress(this.getparat('stress',0,0,'obj'));
      gms = -1; if ( qstresssol ) gms += gm;

      sigma = this.build['constants'].sigma.value;

      ffrac = this.build['constants'].ffrac.value;
      if ( global.common.data.options.completions ) ffrac = this.getparat('poroperm',0,2,'');

      if ( qdip )
      {
        if (  qmat ) dataset += ' DZ  '+th+'  4*  '+ima+' '+imb+' / \n';
        if ( !qmat ) dataset += ' DZ  '+th+'  4*  '+ifr+' '+ifb+' / \n';
      }

      if ( global.common.data.options.completions )
      {
        if (  qmat ) dataset += this.matlayer(ima,imb,scl,sts,rockcfrac,pp.poro*(1-ffrac),pp.perm,sigma,false,gms);
        if ( !qmat ) dataset += this.matlayer(ifr,ifb,scl,sts,gm,pp.poro*ffrac,pp.perm,sigma,true,gms);
      }
      else
      {
        if (  qmat ) dataset += this.matlayer(ima,imb,scl,sts,rockcfrac,pp.poro*(1-ffrac),pp.perm,sigma,false,gms);
        if ( !qmat ) 
        {
          fporo = Math.max(pp.poro*ffrac,this.build['constants'].minfporo.value);
          dataset += this.fraclayer(ifr,ifb,satnfrac,sts,gm,fporo,pp.perm,gms);
        }
      }

      ima += nsublayers;
    }

    //
    // underburden - same as layer 0
    //
    if ( qstresssol && this.getparat('stresssol',0,3,'double')>0 )
    {
      n = this.overburdenlayers();

      dataset += '\n-- Added Underburden '+n+' layers - logarithmic grid  \n';
      imb = ima+n-1;
      ifr = ima+nzf;
      ifb = ifr+n-1;

      rock = this.getparat('layer',this.getparat('layer',0,2,'len')-1,2,'');
      rk  = this.getrockprops(this.getparat('rock',0,0,'obj'),rock);
      pp  = this.getporoperm(this.getparat('poroperm',0,0,'obj'),rk.poroperm);
      gm  = this.getindex(this.getparat('geomech',0,0,'obj'),rk.geomech)+1; // 1-based adressing
      scl = this.getindex(this.getparat('scal',0,0,'obj'),rk.scal);
      sts = this.getstress(this.getparat('stress',0,0,'obj'));
      gms = -1; if ( qstresssol ) gms += gm;

      sigma = this.build['constants'].sigma.value;

      ffrac = this.build['constants'].ffrac.value;

      if ( qdip )
      {
        dz = this.overburdenthickness(dzs);

        imu = ima;
        ifu = ifr;
        for ( i=0; i<dz.length; i++ ) 
        { 
          if (  qmat ) dataset += ' DZ  '+dz[i]+'  4*  '+imu+' '+imu+' / \n';
          if ( !qmat ) dataset += ' DZ  '+dz[i]+'  4*  '+ifu+' '+ifu+' / \n';

          if (  qmat ) dataset += this.matlayer(imu,imu,scl,sts,rockcfrac,pp.poro*(1-ffrac),pp.perm,sigma,false,gms);
          if ( !qmat ) 
          {
            fporo = Math.max(pp.poro*ffrac,this.build['constants'].minfporo.value);
            dataset += this.fraclayer(ifu,ifu,satnfrac,sts,gm,fporo,pp.perm,gms);
          }
          imu++; ifu++;
        }
      }
      else 
      {
        if (  qmat ) dataset += this.matlayer(ima,imb,scl,sts,rockcfrac,pp.poro*(1-ffrac),pp.perm,sigma,false,gms);
        if ( !qmat ) 
        {
          fporo = Math.max(pp.poro*ffrac,this.build['constants'].minfporo.value);
          dataset += this.fraclayer(ifr,ifb,satnfrac,sts,gm,fporo,pp.perm,gms);
        }
      }
    }

    return dataset;
  }

  matlayer(ima,imb,scl,sts,gm,poro,perm,sigma,qfrac,gms)
  {
    var satn = scl+1;
    var pmt = 0; if ( qfrac ) pmt = gm;
    var dataset='\n';
    dataset += ' PORO  '+poro+'  4*  '+ima+' '+imb+' / \n';
    dataset += ' PERMX '+perm+'  4*  '+ima+' '+imb+' / \n';
    dataset += ' SWCR  '+this.getparat('scal',scl,0,'')+'  4*  '+ima+' '+imb+' / \n';
    dataset += ' SOWCR '+this.getparat('scal',scl,1,'')+'  4*  '+ima+' '+imb+' / \n';
    dataset += ' PCW   '+this.getparat('scal',scl,2,'')+'  4*  '+ima+' '+imb+' / \n';
    dataset += ' KRW   '+this.getparat('scal',scl,6,'')+'  4*  '+ima+' '+imb+' / \n';
    dataset += ' KRORW '+this.getparat('scal',scl,8,'')+'  4*  '+ima+' '+imb+' / \n';
    dataset += ' SGCR  '+this.getparat('scal',scl,3,'')+'  4*  '+ima+' '+imb+' / \n';
    dataset += ' SOGCR '+this.getparat('scal',scl,4,'')+'  4*  '+ima+' '+imb+' / \n';
    dataset += ' PCG  ' +this.getparat('scal',scl,5,'')+'  4*  '+ima+' '+imb+' / \n';
    dataset += ' KRG   '+this.getparat('scal',scl,7,'')+'  4*  '+ima+' '+imb+' / \n';
    dataset += ' KRORG '+this.getparat('scal',scl,8,'')+'  4*  '+ima+' '+imb+' / \n';
    dataset += ' KRO   '+this.getparat('scal',scl,8,'')+'  4*  '+ima+' '+imb+' / \n';
    dataset += ' SATNUM '+satn+ '  4* '+ima+' '+imb+' / \n';
    dataset += ' RKSSTRX '+sts.x+'  4*  '+ima+' '+imb+' / \n';
    dataset += ' RKSSTRY '+sts.y+'  4*  '+ima+' '+imb+' / \n';
    dataset += ' RKSSTRZ '+sts.z+'  4*  '+ima+' '+imb+' / \n';
    dataset += ' RKSPMODNUM  '+pmt+'  4* '+ima+' '+imb+' / \n';
    dataset += ' RKSROCKCNUM '+gm+'  4* '+ima+' '+imb+' / \n';
    dataset += ' SIGMAV '+sigma+'  4*  '+ima+' '+imb+' / \n';
    if ( gms>=0 ) // Stress solution
    {
      dataset += ' RKSYOUNG '+ this.getparat('stresssol',gms,1,'')+'  4*  '+ima+' '+imb+' / \n';
      dataset += ' RKSPOISSR '+this.getparat('stresssol',gms,0,'')+'  4*  '+ima+' '+imb+' / \n';
      dataset += ' RKSBIOT '+  this.getparat('stresssol',gms,2,'')+'  4*  '+ima+' '+imb+' / \n';
    }    

    return dataset;
  }

  fraclayer(ifr,ifb,scl,sts,gm,poro,perm,gms)
  {
    var dataset='\n';
    dataset += ' PORO  '+poro+'  4* '+ifr+' '+ifb+' / \n'; 
    dataset += ' PERMX '+perm+'  4* '+ifr+' '+ifb+' / \n'; 
    dataset += ' PCW    0   4* '+ifr+' '+ifb+' / \n'; 
    dataset += ' SWCR   0   4* '+ifr+' '+ifb+' / \n'; 
    dataset += ' SOWCR  0   4* '+ifr+' '+ifb+' / \n'; 
    dataset += ' KRW    1   4* '+ifr+' '+ifb+' / \n'; 
    dataset += ' KRORW  1   4* '+ifr+' '+ifb+' / \n'; 
    dataset += ' PCG    0   4* '+ifr+' '+ifb+' / \n'; 
    dataset += ' SGCR   0   4* '+ifr+' '+ifb+' / \n'; 
    dataset += ' SOGCR  0   4* '+ifr+' '+ifb+' / \n'; 
    dataset += ' KRG    1   4* '+ifr+' '+ifb+' / \n'; 
    dataset += ' KRORG  1   4* '+ifr+' '+ifb+' / \n'; 
    dataset += ' KRO    1   4* '+ifr+' '+ifb+' / \n'; 
    dataset += ' SATNUM '+scl+'   4* '+ifr+' '+ifb+' / \n'; 
    dataset += ' RKSSTRX '+sts.x+'  4*  '+ifr+' '+ifb+' / \n';
    dataset += ' RKSSTRY '+sts.y+'  4*  '+ifr+' '+ifb+' / \n';
    dataset += ' RKSSTRZ '+sts.z+'  4*  '+ifr+' '+ifb+' / \n';
    dataset += ' RKSPMODNUM  '+gm+'  4* '+ifr+' '+ifb+' / \n';
    dataset += ' RKSROCKCNUM '+gm+'  4* '+ifr+' '+ifb+' / \n';

    if ( gms>=0 ) // Stress solution
    {
      dataset += ' RKSYOUNG '+ this.getparat('stresssol',gms,1,'')+'  4*  '+ifr+' '+ifb+' / \n';
      dataset += ' RKSPOISSR '+this.getparat('stresssol',gms,0,'')+'  4*  '+ifr+' '+ifb+' / \n';
      dataset += ' RKSBIOT '+  this.getparat('stresssol',gms,2,'')+'  4*  '+ifr+' '+ifb+' / \n';
    }  

    var sigma = this.build['constants'].sigma.value;
    dataset += '-- Dummy sigma, only the matrix used, however errors otherwise \n';
    dataset += ' SIGMAV '+sigma+'  4* '+ifr+' '+ifb+' / \n';

    dataset += '\n';
  
    return dataset;
  }

  mrhead(dataset,base,cases)
  {
    dataset += '\nMRSENSITIVITY  SONE\n\n';
    dataset += 'STYPE  INDIVIDUAL  /\n';
    dataset += 'VARIABLESET  SET1  /\n';
    dataset += 'VECTORS FOPT FWPT FGPR FOPR  /\n';
    dataset += 'PLOTS DISTRIB  /\n';
    dataset += 'OUTPUT  HTML /\n';
    dataset += ' / \n\n';

    dataset += 'MRCONTROL\n';
    dataset += '  SENSITIVITY  SONE  /\n';
    dataset += '/\n\n';

    dataset += 'MROUTPUT\n';
    dataset += '--    amagamated output\n'
    dataset += '  2*  YES  /\n';
    dataset += '/\n\n';

    var calc = this.getcalc();

    dataset += 'MRVARIABLES  SET1\n';
    dataset += '--  vname   vtype    dtype       default     min    max    mean    sd    peak    n    values\n';
    dataset += '     A      REAL     DISCRETE   '+base+'    6*  ';
    for ( var i=0; i<cases.length; i++ )
    {
      dataset += ' '+cases[i];
    }
    dataset += ' /\n';
    if ( calc!=='' ) dataset += '     D      REAL     DERIVED / \n'; 
    dataset += ' /\n\n';


    if ( calc!=='' )
    {
      dataset += 'MRSCRIPTV \n';
      dataset += calc+'  \n';
      dataset += ' /\n';
      dataset += ' /\n\n';  
    }

    return dataset;
  }

  addsimplewell(iwell,fracs) 
  {
    var well={};

    var depth = this.getparat('well',iwell,0,'float');
    var len   = this.getparat('well',iwell,1,'float');
    var theta = this.getparat('well',iwell,2,'float')-this.getbaseparat('stress',0,3,'float');
    var x0    = this.getparat('well',iwell,3,'float');
    var y0    = this.getparat('well',iwell,4,'float');
    var dev   = this.getparat('well',iwell,5,'float');

    var rtheta = theta*Math.PI/180.0;
    var rdev   = dev*Math.PI/180.0;
    var lenxy  = len*Math.sin(rdev);
    well.name  = this.getparat('well',iwell,0,'name');
    well.md    = [0,len];
    well.x     = [x0,x0+lenxy*Math.cos(rtheta)];
    well.y     = [y0,y0+lenxy*Math.sin(rtheta)];
    well.z     = [depth,depth+len*Math.cos(rdev)];
    well.diam  = [this.build['constants'].welldiam.value,this.build['constants'].welldiam.value];

    well.completions=[];

    for ( var ifr=0; ifr<fracs.length; ifr++ )
    {
      var frac = fracs[ifr];
      var ifrac = this.getindex(this.getparat('frac',0,0,'obj'),fracs[ifr]);
      var icomp = this.getindex(this.getparat('completion',0,0,'obj'),fracs[ifr]);

      if ( global.common.data.options.completions && icomp>=0  ) this.addcomp(frac,icomp,len,well);
      else if ( ifrac>=0 )                                       this.addfrac(frac,ifrac,len,well,false);
    }

    return well;
  }

  //
  // Add the fracture geometry to the well - fracture mode
  //
  addfrac(frac,ifrac,len,well,qend)
  {
    var name   = this.getparat('frac',ifrac,0,'name');
    var nstage = this.getparat('frac',ifrac,0,'float');
    var slen   = this.getparat('frac',ifrac,1,'float');
    var sgap   = this.getparat('frac',ifrac,2,'float');
    var nclust = 0; // cluster not currently used

    var totf = nstage*slen+(nstage-1)*sgap;
    if ( totf>len )
    {
      var ns=nstage;
      for ( var is=0; is<nstage; is++ )
      {
        ns = nstage-is;
        totf = ns*slen+(ns-1)*sgap;
        if ( totf<len ) break;
      }
      if ( ns<nstage ) global.alertx('Total frac length('+totf+') exceeds well length, number of stages reduced to '+ns,false);
      nstage=ns;
    }

    var rest  = len - nstage*slen -(nstage-1)*sgap;
    var start = len - rest/2 - slen;
    if ( qend ) start = len - slen;

    for ( is=0; is<nstage; is++ )
    {
      var comp={};
      comp.name = well.name + ":" +name+is; 
      comp.name = comp.name.replace(/ /g, "_");
      comp.md = [start,start+slen];
      if ( nclust>0 )
      {
        comp.clustern = nclust;
        comp.clusterspacing = slen/nclust-1; // default cluster length = 1ft
      }
      if ( global.common.data.options.perfflow )
      {
        comp.perfd = this.build['constants'].perfdiam.value;
        comp.perfn = 20;
      }
      start -= slen+sgap;
      well.completions.push(comp);
    }
  }

  //
  // Add a completion in completions mode
  //
  addcomp(name,icomp,len,well)
  {
    var start = this.getparat('completion',icomp,0,'float');
    var slen  = this.getparat('completion',icomp,1,'float');
    var skin  = this.getparat('completion',icomp,2,'float');

    var comp={};
    comp.name = name;
    comp.md   = [start,start+slen];
    comp.skin = skin;
    well.completions.push(comp);
  }

  addsimplefrac(isched,jsonwell) 
  {
    var frac  = this.getparat('schedule',isched,1,'');

    var ifrac = this.checkexistst('frac',frac);
    
    ifrac  = this.getindex(this.getparat('frac',0,0,'obj'),frac);

    if ( this.getparat('frac',ifrac,0,'type')==='simple' )
    {
      jsonwell.completions = [];
      var len = jsonwell.md[jsonwell.md.length-1];
      this.addfrac(frac,ifrac,len,jsonwell,true)
    }
  }



  addmultistage(isched,rksjson) 
  {
    var well  = this.getparat('schedule',isched,0,'');
    var frac  = this.getparat('schedule',isched,1,'');
    var start = this.getparat('schedule',isched,2,'');

    var ifrac = this.checkexistst('frac',frac);
    var stage = this.getparat('frac',ifrac,3,'');
    var istag = this.checkexistst('stages',stage);
    var mbhp  = this.getparat('stages',istag,4,'float');

    var jsonwell={};
    for ( var i=0; i<rksjson.wells.length; i++ )
    {
      if ( rksjson.wells[i].name===well ) jsonwell=rksjson.wells[i];
    }

    var istage = this.getindex(this.getparat('stages',0,0,'obj'),stage);
    ifrac  = this.getindex(this.getparat('frac',0,0,'obj'),frac);

    var nstage=0;
    var qperf=true;
    if ( this.getparat('frac',ifrac,0,'type')==='simple' )
    {
      var nstage_wanted = this.getparat('frac',ifrac,0,'int');
    }
    else
    {
      nstage_wanted = this.getparat('frac',0,0,'obj')[ifrac].nstage;
      for ( var ic=0; ic<jsonwell.completions.length; ic++ )
      {
        if ( typeof jsonwell.completions[ic].perfd==='undefined' ) qperf=false;
      }
    }
    nstage = jsonwell.completions.length;
    if ( nstage!==nstage_wanted ) global.alertx('problem with number of stages');

    var rate  = [];
    var time  = [];

    rate.push(this.getparat('stages',istage,0,'float')*60*24);
    time.push(this.getparat('stages',istage,1,'float')/(60*24));   // Duration & gap in minutes
    var gtime = this.getparat('stages',istage,2,'float')/(60*24);

    var events = [];
    
    var date = new Date(this.startdate.getTime()+start*24*60*60*1000);
    var sdate = this.getecldate(date);
    if ( start>0 ) events.push({ time: date.getTime(), keyword: 'DATES\n '+sdate+' / \n / \n\n' });

    if ( !global.common.data.options.perfflow || (this.getparat('frac',0,0,'type')==='imported'&&!qperf) )
    {
      var keyword = 'RKSWTMODMIN\n '
      keyword += well+'  1E10  / \n /\n\n';
      events.push({ time: date.getTime()+1, keyword: keyword });
    }

    keyword = 'RKSWORKOVER\n '
    keyword += well+'  *  SHUT  / \n /\n\n';
    events.push({ time: date.getTime()+2, keyword: keyword });

    for ( var is=0; is<nstage; is++ )
    {
      keyword = 'RKSWORKOVER\n '
      keyword += well+' \''+jsonwell.completions[is].name+'\' OPEN / \n /\n\n';
      events.push({ time: date.getTime()+3, keyword: keyword });

      keyword = 'RKSTUNE\n ';
      keyword += '  0.0005 /\n\n';
      events.push({ time: date.getTime()+4, keyword: keyword });
      
      for ( var ir=0; ir<time.length; ir++ )
      {
        keyword = 'WCONINJE\n '+well+' WATER OPEN RATE '+rate[ir]+' 1*  '+mbhp+' / \n / \n\n'
        events.push({ time: date.getTime()+5, keyword: keyword });
        var tmp = date.getTime() + time[ir]*24*60*60*1000;
        date = new Date(tmp);
        sdate = this.getecldate(date);
        events.push({ time: date.getTime(), keyword: 'DATES\n '+sdate+' / \n / \n\n' });
      }

      keyword = 'RKSWORKOVER\n '
      keyword += well+' \''+jsonwell.completions[is].name+'\' SHUT / \n / \n\n';
      events.push({ time: date.getTime()+1, keyword: keyword });

      if ( !global.common.data.options.perfflow && is===nstage-1 )
      {
        keyword = 'RKSWTMODMIN\n '
        keyword += well+'  1 / \n /\n\n';
        events.push({ time: date.getTime()+1, keyword: keyword });
      }

      keyword = 'WCONINJE\n '+well+' WATER SHUT / \n / \n\n';
      events.push({ time: date.getTime()+2, keyword: keyword });

      if ( is===nstage-1 )
      {
        keyword = 'RKSOUT\n\n';
        events.push({ time: date.getTime()+3, keyword: keyword });

        keyword = 'RKSWORKOVER\n '
        keyword += well+'  *  OPEN / \n / \n\n';
        events.push({ time: date.getTime()+4, keyword: keyword });
    
        keyword = 'WCONPROD\n '
        keyword += well+' STOP  BHP  /\n / \n\n';
        events.push({ time: date.getTime()+5, keyword: keyword });

        keyword = 'RKSTUNE\n  0.001 / \n\n';
        events.push({ time: date.getTime()+6, keyword: keyword });
      }
      else
      {
        tmp = date.getTime() + gtime*24*60*60*1000;
        date = new Date(tmp);
        sdate = this.getecldate(date);
        events.push({ time: date.getTime(), keyword: 'DATES\n '+sdate+' / \n / \n\n' });
      }
    }

    return events;
  }

  addsinglestage(isched)  // completions option
  {
    var well  = this.getparat('schedule',isched,0,'');
    var frac  = this.getparat('schedule',isched,1,'');
    var start = this.getparat('schedule',isched,2,'');

    var ifrc  = this.getindex(this.getparat('completion',0,0,'obj'),frac); 
    var stage = this.getparat('completion',ifrc,3,'');

    var istage = this.getindex(this.getparat('stages',0,0,'obj'),stage);

    var rate  = [];
    var time  = [];

    rate.push(this.getparat('stages',istage,0,'float'));
    time.push(this.getparat('stages',istage,1,'float')/(60*24));   // Duration & gap in minutes
    var gtime = this.getparat('stages',istage,2,'float')/(60*24);

    var events = [];
    
    var date = new Date(this.startdate.getTime()+start*24*60*60*1000);
    var sdate = this.getecldate(date);
    if ( start>0 ) events.push({ time: date.getTime(), keyword: 'DATES\n '+sdate+' / \n / \n\n' });

    if ( !global.common.data.options.perfflow )
    {
      var keyword = 'RKSWTMODMIN\n '
      keyword += well+'  1E10  / \n /\n\n';
      events.push({ time: date.getTime()+1, keyword: keyword });
    }

    keyword = 'RKSWORKOVER\n '
    keyword += well+'  *  SHUT  / \n /\n\n';
    events.push({ time: date.getTime()+2, keyword: keyword });

    keyword = 'RKSWORKOVER\n '
    keyword += well+' '+frac+' OPEN / \n /\n\n';
    events.push({ time: date.getTime()+3, keyword: keyword });

    keyword = 'RKSTUNE\n ';
    keyword += '  0.0005 /\n\n';
    events.push({ time: date.getTime()+4, keyword: keyword });
      
    for ( var ir=0; ir<time.length; ir++ )
    {
      keyword = 'WCONINJE\n '+well+' WATER OPEN RATE '+rate[ir]+' 1*  12000 / \n / \n\n'
      events.push({ time: date.getTime()+5, keyword: keyword });

      if ( ir===time.length-1 )
      {
        keyword = 'RKSOUT\n\n';
        events.push({ time: date.getTime()+6, keyword: keyword });
      }

      var tmp = date.getTime() + time[ir]*24*60*60*1000;
      date = new Date(tmp);
      sdate = this.getecldate(date);
      events.push({ time: date.getTime(), keyword: 'DATES\n '+sdate+' / \n / \n\n' });
    }

    if ( !global.common.data.options.perfflow )
    {
      keyword = 'RKSWTMODMIN\n '
      keyword += well+'  1 / \n /\n\n';
      events.push({ time: date.getTime()+1, keyword: keyword });
    }

    keyword = 'WCONINJE\n '+well+' WATER SHUT / \n / \n\n';
    events.push({ time: date.getTime()+2, keyword: keyword });

    tmp = date.getTime() + gtime*24*60*60*1000;
    date = new Date(tmp);
    sdate = this.getecldate(date);
    events.push({ time: date.getTime(), keyword: 'DATES\n '+sdate+' / \n / \n\n' });

    return events;
  }

  //
  // Completion mode - open/close completion
  //
  openclose(well,comp,start,qopen) 
  {
    var events=[];

    var date = new Date(this.startdate.getTime()+start*24*60*60*1000);

    if ( start>1e-3 )
    {
      var sdate = this.getecldate(date);
      events.push({ time: date.getTime(), keyword: 'DATES\n '+sdate+' / \n / \n\n' });
    }
    
    var keyword = 'RKSWORKOVER\n '
    if ( qopen )  keyword += well+'  '+comp+'  OPEN  / \n /\n\n';
    else          keyword += well+'  '+comp+'  SHUT  / \n /\n\n';
    events.push({ time: date.getTime()+1, keyword: keyword });

    return events;
  }

  getecldate(date)
  {
    var sdate = date.getDate()+' '+global.common.months[date.getMonth()]+' '+date.getFullYear() + ' '+ date.getHours()+':'+date.getMinutes()+':'+date.getSeconds();
    return sdate;
  }

  addproduction(iprod,well,time) 
  {
    var events = [];

    var bhp  = this.getparat('production',iprod,0,'float');
    var rate = this.getparat('production',iprod,1,'float');
    var init = '';
    if ( global.common.data.options.completions )  init = this.getparat('production',iprod,4,'');
    var econ = this.getparat('production',iprod,2,'float');

    var date = new Date(this.startdate.getTime() + time*24*60*60*1000);

    var keyword = 'RKSOUT\n\n';
    events.push({ time: date.getTime(), keyword: keyword });

    if ( time>0 )
    {
      var sdate = this.getecldate(date);
      events.push({ time: date.getTime()+1, keyword: 'DATES\n '+sdate+' / \n / \n\n' });
    }

    if ( !global.common.data.options.completions ) 
    {
      keyword = 'RKSWORKOVER\n '
      keyword += well+'  *  OPEN / \n / \n\n';
      events.push({ time: date.getTime()+2, keyword: keyword });
    }

    keyword = 'WCONPROD\n '

    keyword += well+' OPEN  BHP  3*  '+rate+' 1* '+bhp+' 3* '+init+' /\n / \n\n';
    events.push({ time: date.getTime()+3, keyword: keyword });

    if ( econ>0.1 )
    {
      keyword = 'WECON\n '

      keyword += well+' '+econ+'  4*  WELL  ALL  /\n / \n\n';
      events.push({ time: date.getTime()+4, keyword: keyword });
    }

    keyword = 'RKSTUNE\n  0.1 / \n\n';
    events.push({ time: date.getTime()+5, keyword: keyword });

    return events;
  }

  endproduction(iprod,well,start) 
  {
    var events = [];

    var etime = this.getparat('production',iprod,3,'float');

    var date = new Date(this.startdate.getTime() + (start+etime*365)*24*60*60*1000);

    if ( etime>0 )
    {
      var nyear = Math.floor(etime);
      for ( var iyear=1; iyear<nyear; iyear++ )
      {
        var date1 = new Date(this.startdate.getTime() + iyear*0.5*365*24*60*60*1000);
        var sdate1 = this.getecldate(date1);
        events.push({ time: date1.getTime()+1, keyword: 'DATES\n '+sdate1+' / \n / \n\n' });

        date1 = new Date(this.startdate.getTime() + iyear*365*24*60*60*1000);
        sdate1 = this.getecldate(date1);
        events.push({ time: date1.getTime()+1, keyword: 'DATES\n '+sdate1+' / \n / \n\n' });
      }

      var sdate = this.getecldate(date);
      events.push({ time: date.getTime()+1, keyword: 'DATES\n '+sdate+' / \n / \n\n' });
    }

    var keyword = 'WCONPROD\n '

    keyword += well+' SHUT   /\n / \n\n';
    events.push({ time: date.getTime()+3, keyword: keyword });

    return events;
  }

  layerorder(data,index)
  {
    return { order: parseFloat(data.para[0].value), dz: parseFloat(data.para[1].value), layer: index }
  }

  getrockprops(rocks,rock)
  {
    var ret={};
    for ( var i=0; i<rocks.length; i++ )
    {
      if ( rocks[i].name===rock )
      {
        ret={ poroperm: this.getpara(rocks,'rock',i,0,''), geomech: this.getpara(rocks,'rock',i,1,''), scal: this.getpara(rocks,'rock',i,2,'') };
        break;
      }
    }
    return ret;
  }

  getstress(stresses)
  {
    var iglb=0;
    var ret={ x: this.getpara(stresses,'stress',iglb,0,'float'), y: this.getpara(stresses,'stress',iglb,1,'float'), z: this.getpara(stresses,'stress',iglb,2,'float') };
    return ret;
  }

  getporoperm(poroperms,poroperm)
  {
    var ret={};
    for ( var i=0; i<poroperms.length; i++ )
    {
      if ( poroperms[i].name===poroperm )
      {
        var poro  = this.getpara(poroperms,'poroperm',i,0,'float');
        var perm  = this.getpara(poroperms,'poroperm',i,1,'float');
        var nporo=2;
        ret={ poro: poro, perm: perm, nporo: nporo };
        break;
      }
    }
    return ret;
  }

  getfracs(schedules,well)
  {
    var ret=[];
    for ( var i=0; i<schedules.length; i++ )
    {
      if ( schedules[i].para[0].value===well )
      {
        ret.push(this.getpara(schedules,'schedule',i,1,''));
      }
    }
    return ret;
  }

  getwellusingfrac(schedules,frac)
  {
    var ret=[];
    for ( var i=0; i<schedules.length; i++ )
    {
      if ( schedules[i].para[1].value===frac )
      {
        ret.push(this.getpara(schedules,'schedule',i,0,''));
      }
    }
    return ret;
  }

  getindex(things,thing)
  {
    var ret=-1;
    for ( var i=0; i<things.length; i++ )
    {
      if ( things[i].name===thing )
      {
        ret=i;
        break;
      }
    }
    return ret;
  }


  //
  // Write out imported pvt data
  //
  pvt(json)
  {
    var dataset='';

    for (const key in json)
    {
      console.log('key: ',key);
      dataset += key.toUpperCase()+'\n ';
      if ( key.toLowerCase()==="pvto" )
      {   
        var pvto = json[key];
        for ( var it=0; it<pvto.length; it++ )
        {   
          for ( var i=0; i<pvto[it].data.length; i++ )
          {
            dataset += this.format(pvto[it].data[i].rs,10)+' ';
            for ( var j=0; j<pvto[it].data[i].vl.length; j++ )
            {
              if ( j>0 ) dataset += '           ';
              dataset += this.format(pvto[it].data[i].vl[j].psat,10) + ' ' + this.format(pvto[it].data[i].vl[j].bo,10) + ' '+ this.format(pvto[it].data[i].vl[j].visc,10);
              if ( j===pvto[it].data[i].vl.length-1 ) dataset += ' / \n ';
              else                                    dataset += ' \n ';
            }
          }

          dataset += ' / \n';
        }
        dataset += '  \n';
      }
      if ( key.toLowerCase()==="pvdg" )
      {
        var pvdg = json[key];
        for ( it=0; it<pvdg.length; it++ )
        {  
          for ( i=0; i<pvdg[it].length; i++ )
          {
            dataset += this.format(pvdg[it].data[i].pres,10) + ' ' + this.format(pvdg[it].data[i].bg,10)  + ' '+ this.format(pvdg[it].data[i].visc,10)  +' \n ';
          }
          dataset += ' / \n';
        }
        dataset += '  \n';
      }
      if ( key.toLowerCase()==="density" )
      {
        var den = json[key];
        for ( it=0; it<den.length; it++ )
        {
          dataset += this.format(den[it].oil,10)  + ' ' + this.format(den[it].water,10)  + ' '+ this.format(den[it].gas,10)  +' / \n ';
        }
        dataset += '  \n';
      }
      if ( key.toLowerCase()==="pvco" )
      {
        var pvco = json[key];
        for ( it=0; it<pvco.length; it++ )
        {
          for ( i=0; i<pvco[it].length; i++ )
          {
            dataset += this.format(pvco[it].data[i].psat,10) + ' ' + this.format(pvco[it].data[i].rs,10)+ ' ' + this.format(pvco[it].data[i].bo,10) + ' '+ this.format(pvco[it].data[i].visc,10)+ ' ' + this.format(pvco[it].data[i].co,10)+ ' ' + this.format(pvco[it].data[i].cv,10) +' \n ';
          }
          dataset += ' / \n';
        }
        dataset += '  \n';
      }
      if ( key.toLowerCase()==="pvtg" )
      {
        var pvtg = json[key];
        for ( it=0; it<pvtg.length; it++ )
        {
          for ( i=0; i<pvtg[it].data.length; i++ )
          {
            dataset += this.format(pvtg[it].data[i].psat,10)+' ';
            for ( j=0; j<pvtg[it].data[i].vl.length; j++ )
            {
              if ( j>0 ) dataset += '  ';
              dataset += this.format(pvtg[it].data[i].vl[j].rv,10) + ' ' + this.format(pvtg[it].data[i].vl[j].bg,10) + ' '+ this.format(pvtg[it].data[i].vl[j].visc,10);
              if ( j===pvtg[it].data[i].vl.length-1 ) dataset += ' / \n ';
              else                                    dataset += ' \n ';
            }
          }

          dataset += ' / \n';
        }
        dataset += '  \n';
      }
      if ( key.toLowerCase()==="pvtw" )
      {
        var pvtw = json[key];
        for ( it=0; it<pvtw.length; it++ )
        {
          if ( typeof pvtw.cv==='undefined' ) pvtw.cv = 0.0;
          dataset += this.format(pvtw[it].pref,10)  + ' ' + this.format(pvtw[it].bw,10)  + ' '+ this.format(pvtw[it].co,10) + ' '+ this.format(pvtw[it].visc,10) + ' '+ this.format(pvtw[it].cv,10)  +' / \n ';
          dataset += ' \n';
        }
        dataset += '  \n';
      }
    }

    return dataset;
  }

  calcz(dipp,x,y)
  {
    var xo = x-dipp[0].value;
    var yo = y-dipp[1].value;

    var rot = -2*Math.PI*(dipp[3].value-this.getbaseparat('stress',0,3,'float'))/360;
    var a00 = Math.cos(rot); var a01 = -Math.sin(rot);
  //var a10 = Math.sin(rot); var a11 =  Math.cos(rot);

    var xx = a00*xo + a01*yo;
  //var yx = a10*xo + a11*yo;

    var dip = -2*Math.PI*dipp[2].value/360;
    
    var z = xx*Math.tan(dip);
    
    return z;
  }

  format(num,size)
  {
    var ret='';
    ret += num;
    for ( var i=ret.length; i<size; i++ )
    {
      ret += ' ';
    }
    return ret;
  }

  copyobj(objin) // as it says
  {
    var serial = JSON.stringify(objin);
    return JSON.parse(serial);
  }

  overburdenlayers()
  {
    var nzf=0;
    for ( var ilay=0; ilay<this.getparat('layer',0,0,'len'); ilay++ )
    {
      nzf += this.getparat('layer',ilay,3,'float');
    }

    var nd = Math.log(nzf*this.getparat('stresssol',0,3,'double'))/Math.log(2);
    var n = parseInt(nd+1);
   
    return n;
  } 

  overburdenthickness(dzs)
  {
    var dztot=0;
    for ( var i=0; i<this.getparat('layer',0,0,'len'); i++ ) dztot += dzs[i].dz;

    var nex = this.overburdenlayers();
    var dz = new Array(nex);
    dz[0] = dztot/this.getparat('layer',0,0,'len');

    for ( i=1; i<nex; i++ )  dz[i] = 2*dz[i-1]; 

    return dz;
  }


}

export default Build
